import React from 'react';
import { Platform } from 'react-native';
import { useUpdate } from '../Utils/UpdateProvider';
import UpdateModal from './UpdateModal';

const AppUpdateHandler: React.FC = () => {
  // Always call hooks at the top level (React rules)
  // On web, UpdateProvider returns safe defaults, so this is fine
  const {
    updateAvailable,
    updateStatus,
    isUpdating,
    showUpdateModal,
    setShowUpdateModal,
    startUpdate,
    installUpdate,
    updateError,
    storeVersion,
    currentVersion
  } = useUpdate();

  // On web, don't show update handler (updates are handled by browser/server)
  if (Platform.OS === 'web') {
    return null;
  }

  const handleUpdate = async (type: 'flexible' | 'immediate') => {
    await startUpdate(type);
  };

  const handleInstall = async () => {
    await installUpdate();
  };

  const handleClose = () => {
    setShowUpdateModal(false);
  };

  // Don't render if no update available
  if (!updateAvailable && !showUpdateModal) {
    return null;
  }

  return (
    <UpdateModal
      visible={showUpdateModal}
      onClose={handleClose}
      onUpdate={handleUpdate}
      onInstall={handleInstall}
      updateStatus={updateStatus}
      isMandatory={false} // You can make this configurable
      storeVersion={storeVersion}
      currentVersion={currentVersion}
    />
  );
};

export default AppUpdateHandler;
